import AtomCheckbox from '@/components/Atoms/AtomCheckbox/AtomCheckbox'
import AtomFormInput from '@/components/Atoms/AtomFormInput/AtomFormInput'
import AtomTreeSelect from '@/components/Atoms/AtomTreeSelect/AtomTreeSelect'
import HoverElement from '@/components/Atoms/HoverElement/HoverElement'
import type {
  FormInputControlType,
  FormInputRegisterType,
  TreeSelectFormControlType,
} from '@/types'

import cn from '../TreeEntityCreationModal.module.scss'
import type useTreeEntityCreationForm from '../useTreeEntityCreationForm'

type TreeEntityCreationFormFieldsPropsType = {
  treeType: 'categories' | 'nomenclature-groups'
  form: ReturnType<typeof useTreeEntityCreationForm>
}

function TreeEntityCreationFormFields(
  props: TreeEntityCreationFormFieldsPropsType
) {
  const { treeType, form } = props
  const {
    register,
    control,
    errors,
    watch,
    setValue,
    tree,
    antdTree,
    pathToSelectedNode,
    isApprover,
    handleChangeTreeSelect,
    handleClearTreeSelect,
  } = form

  return (
    <>
      <HoverElement>
        <AtomTreeSelect
          layout="stacked"
          tree={tree}
          antdTree={antdTree}
          handleChange={handleChangeTreeSelect}
          openByHover={false}
          title={`Родительская ${treeType === 'categories' ? 'категория' : 'группа'}`}
          placeholder="Без родителя"
          formName="parentId"
          formControl={control as TreeSelectFormControlType}
          formErrors={errors}
          handleClear={handleClearTreeSelect}
        />
      </HoverElement>
      {pathToSelectedNode && (
        <p className={cn.selectedPath}>
          <span className={cn.selectedPathLabel}>Выбрано:</span>{' '}
          {pathToSelectedNode}
        </p>
      )}
      <AtomFormInput
        layout="stacked"
        idPrefix="tree-entity-"
        location="treeEntityCreation"
        register={register as FormInputRegisterType}
        control={control as unknown as FormInputControlType}
        name="description"
        title="Наименование"
        placeholder={
          treeType === 'categories' ? 'Например, котлы' : 'Например, краны'
        }
        errors={errors}
        required
      />
      {treeType === 'categories' && isApprover && (
        <AtomCheckbox
          className={cn.checkbox}
          checked={watch('approveImmediately') ?? true}
          onChange={(checked) => setValue('approveImmediately', checked)}
        >
          Сразу утвердить
        </AtomCheckbox>
      )}
    </>
  )
}

export default TreeEntityCreationFormFields
